import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { ObjPayment } from './../../../models/Booking/ReservationSaveAndConfirmModel';
import { ProceedPaymentModel } from './../../../models/Payments/ProceedPaymentModel';
import { SearchService } from './../../../services/search.service';
import { BookingService } from './../../../services/booking.service';
import { Component, Input, OnInit, AfterViewInit, Renderer2, ViewChild, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { DepositeType, PaymentGatewayMethodEnum, PaymentMethodsEnum, PaymentMode, ProceedPaymentResponseResult, RentalServiceDeliveryChannel } from 'src/app/models/enums/Payments/PaymnetsEnum'
import { ReservationSaveAndConfirmModel, ReservationSaveAndConfirmResultModel } from 'src/app/models/Booking/ReservationSaveAndConfirmModel';
import { AvailablePaymentMethodModel } from 'src/app/models/Payments/AvailablePaymentMethodModel';
import { DepositPolicyModel, LstPolicyReservationCaseModel } from 'src/app/models/VehicleReservationCaseDetailsModel';
import { DepositPolicyPaymentTypes, PolicyType } from 'src/app/models/enums/BookingEnums';
import { Router } from '@angular/router';
import { faClipboard, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { PaymentModel } from 'src/app/models/Booking/PaymentModel';
import { CustomerPaymentMethodModel } from 'src/app/models/Profile/CustomerPaymentMethodModel';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';



declare const $: any;
declare const paylib: any;
declare const payTabsInit: any;
@Component({
  selector: 'payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit, AfterViewInit, OnDestroy {

  faDollarSign = faDollarSign;
  faClipboard = faClipboard;
  math = Math;
  paymentForm: FormGroup;
  visaForm: FormGroup;
  chequeForm: FormGroup;
  ACHForm: FormGroup;

  submitted = false;
  selectedMethod;
  PaymentMethods;
  paymentMethodList: AvailablePaymentMethodModel[];
  reservationSaveAndConfirmModel: ReservationSaveAndConfirmResultModel;
  objPayment: ObjPayment;
  @Input() listOfPolicies: LstPolicyReservationCaseModel[];
  depositePolicy: DepositPolicyModel;
  depositeType;
  currency: any;
  accountCreditPostBackMsg: string;
  SavedPayments;
  visaClicked = false;
  UseAnotherPayment = true;//this incase there is a save cards and he want to enter a new one
  customerPaymentMethods: CustomerPaymentMethodModel[];
  //Static customeID
  //customerID = "256a8435-e34a-41be-b557-4462b88d5733";

  customer;
  payTabsContent: any;

  @ViewChild('payTabHtmlContainer') payTabHtmlContainer;
  payTabsCustomerDetailsForm: FormGroup;
  customerDetails: { name: any; email: any; country: string; street1: any; city: string; };
  paymentGatewayMethod: PaymentGatewayMethodEnum;
  payTabsFormIsDisable: boolean;
  payTabsPaymentMethod: AvailablePaymentMethodModel;

  constructor(private formBuilder: FormBuilder,
    private bookingService: BookingService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private renderer2: Renderer2,
    private translate: TranslateService,
    private searchService: SearchService) {

    this.currency = searchService.getCurrency();

  }
  ngOnDestroy(): void {

  }


  form = new FormGroup({
    customerName: new FormControl('',),
    cardNo: new FormControl('',),
    securityCode: new FormControl(null, Validators.required),
    expiryDateMonth: new FormControl(null, Validators.required),
    expiryDateYear: new FormControl(null, Validators.required),
  });


  ngOnInit() {

    this.depositeType = DepositPolicyPaymentTypes.FullPaymentIsRequired;


    if (this.listOfPolicies != null) {

      let policy = this.listOfPolicies.filter(a => a.policyDefinitionId == PolicyType.DepositPolicy)[0];
      this.depositePolicy = policy.depositPolicyModel;

    }
    this.authService.loggedInCustomer.subscribe(res => {


      this.customer = res;
      let customerDetails = {
        name: this.customer.defaultName,
        email: this.customer.primaryEmail,
        country: "BR",
        street1: this.customer.fullAdress,
        city: "AMM",
      }
      this.customerDetails = customerDetails;




      //This if we have saved cards now we dont have
      // this.authService.getCustomerPaymentMethods(this.customer.customerID).subscribe(res => {

      //   this.customerPaymentMethods = res;
      //   if (this.customerPaymentMethods.length == 0) {
      //     this.UseAnotherPayment = true;
      //   }
      // })

    })


    this.bookingService.reservationSaveAndConfirmModel.subscribe(res => {


      if (res != null && res.result != "") {

        this.reservationSaveAndConfirmModel = JSON.parse(res.result);

        this.objPayment = res.objPayment;
        this.bookingService.cachedBookingCaseID(this.reservationSaveAndConfirmModel.CaseID)
        //Check If Full Payment policy is exist
        if (res.objPayment != null && res.objPayment.depositPolicyPaymentTypes != null) {
          let types = res.objPayment.depositPolicyPaymentTypes;
          let fullPayment = types.filter(a => a == DepositPolicyPaymentTypes.FullPaymentIsRequired);
          if (fullPayment == null) {
            //If no Full Payment policy set any policy as default
            this.depositeType = types[0];
          }
        }


      }
      else {

      }


    })


    this.paymentForm = this.formBuilder.group({
      FullAmount: ['', Validators.required],
      SecurityDeposit: ['', Validators.required],
    });
    this.visaForm = this.formBuilder.group({
      CardNumber: ['', Validators.required],
      Provider: ['', Validators.required],
      CardHolderName: ['', Validators.required],
      ExpiryMonth: ['', Validators.required],
      ExpiryYear: ['', Validators.required],
      CVC: ['', Validators.required],
    });
    this.chequeForm = this.formBuilder.group({
      ChequeNumber: ['', Validators.required],
      BankName: ['', Validators.required],
      ChequeDate: ['', Validators.required],
    });
    this.ACHForm = this.formBuilder.group({
      BankAccount: ['', Validators.required],
      BankName: ['', Validators.required],
      AccountName: ['', Validators.required],
      Routing: ['', Validators.required],
    });





  }

  ngAfterViewInit(): void {

  }

  get DepositPolicyPaymentTypes() {
    return DepositPolicyPaymentTypes;
  }
  // convenience getter for easy access to form fields
  get paymentInfo() { return this.paymentForm.controls; }
  get visaInfo() { return this.visaForm.controls; }
  get chequeInfo() { return this.chequeForm.controls; }
  get ACHInfo() { return this.ACHForm.controls; }

  get paymentMethods() {
    return PaymentMethodsEnum;
  }

  get tenantRegisteredPaymentGatewayMethods() {
    if (this.paymentMethodList == null || this.selectedMethod == null) {
      return null;
    }
    let paymentMehtods = this.paymentMethodList.filter(a => a.paymentGatewayLookupID == this.selectedMethod);
    if (paymentMehtods != null) {
      return paymentMehtods[0].lstTenantRegisteredPaymentGatewayMethods;
    }
    return null;
  }

  get PaymentMode() {
    return PaymentMode;
  }
  get RentalServiceDeliveryChannel() {
    return RentalServiceDeliveryChannel;
  }

  public get payTabsContentSafe(): SafeHtml {
    if (this.payTabsContent != null) {
      return this.sanitizer.bypassSecurityTrustHtml(this.payTabsContent);
    }
    return null;

  }


  get paymentGatewayMethodEnum() {
    return PaymentGatewayMethodEnum;
  }

  get payTabsPaymentMethods() {
    if (this.paymentMethodList != null) {

      let payTabPaymentMethod = this.paymentMethodList.filter(a => a.paymentGatewayLookupID == PaymentMethodsEnum.PayTabs)[0];
      if (payTabPaymentMethod != null) {
        return payTabPaymentMethod.lstTenantRegisteredPaymentGatewayMethods.filter(a => a.isActive);
      }

    }
    return null;

  }


  onSubmit() {
    debugger;
    this.submitted = true;

    // stop here if form is invalid
    if (this.paymentForm.invalid) {
      return;
    }

    // display form values on success
    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.paymentForm.value, null, 4));
  }

  onReset() {
    this.submitted = false;
    this.paymentForm.reset();
  }

  method: string = 'visa';
  changeComboo(event) {
debugger
    if (event.value == PaymentMethodsEnum.PayTabs) {

    let payTabMethod=this.payTabsPaymentMethod;
    if(payTabMethod!=null){
      let payTabSetting=JSON.parse( payTabMethod.registeredPaymentGatewaySettingsJson);
      setTimeout(() => {
        payTabsInit(payTabSetting.ClientKey, this.customerDetails, this.onSubmitPayTabs, this.updatePayTabsCardType, this);
      });
    }
    }

    this.visaClicked = false;
  }

  proceedPayment(paymentMethod) {
    debugger
    this.accountCreditPostBackMsg = null;

    let req: ProceedPaymentModel = {

      caseID: this.reservationSaveAndConfirmModel.CaseID,
      depositeTypeEnum: this.depositeType,
      paymentMethod: paymentMethod,
      paymentMode: PaymentMode.New,
      rentalServiceDeliveryChannelID: RentalServiceDeliveryChannel.Online
    }

    this.callProceedPayment(paymentMethod, req);

  }

  callProceedPayment(paymentMethod, req) {
    debugger
    this.bookingService.proceedPayment(req).subscribe(res => {

      if (res != null) {
        switch (paymentMethod) {
          case PaymentMethodsEnum.PayPal:
            window.location.href = res['url'];
            break;
          case PaymentMethodsEnum.AccountCredit:

            this.handleAccountCreditResponse(res);
            break;
          case PaymentMethodsEnum.NoPaymentRequired:
            this.handleAccountCreditResponse(res["result"]);
            break;
          case PaymentMethodsEnum.PayTabs:
            this.handlePayTabsResponse(res);
            break;
        }

      }



    })
  }
  handlePayTabsResponse(res: Object) {
    debugger
    let result = res["result"];

    switch (result) {
      case ProceedPaymentResponseResult.Success:
        this.router.navigate(['./ConfirmationComponent', { caseID: this.reservationSaveAndConfirmModel.CaseID }]);
        break;
      case ProceedPaymentResponseResult.Required3DAuth:
        window.location.href = res['url'];
        break;
      case ProceedPaymentResponseResult.Failed:
        this.translate.get('SomethingWentWrong').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        })

        break;
    }

  }

  handleAccountCreditResponse(res) {
    let result = res["result"];

    switch (result) {
      case ProceedPaymentResponseResult.Success:
        this.router.navigate(['./ConfirmationComponent', { caseID: this.reservationSaveAndConfirmModel.CaseID }]);
        break;
      default:
        this.accountCreditPostBackMsg = res["msg"];
        break;
    }

  }
  handleNoRequiredPaymentResponse(res) {
    let result = res["result"];

    switch (result) {
      case ProceedPaymentResponseResult.Success:
        this.router.navigate(['./ConfirmationComponent', { caseID: this.reservationSaveAndConfirmModel.CaseID }]);
        break;
      default:
        this.accountCreditPostBackMsg = res["msg"];
        break;
    }

  }
  onclickVisa() {
    this.visaClicked = true;
  }

  payTabSubmit() {

  }

  onSubmitPayTabs(response) {
    debugger

    document.getElementById('paymentErrors').innerHTML
    if (response != null && response.token != null) {
      this.accountCreditPostBackMsg = null;

      let paymentMethod = PaymentMethodsEnum.PayTabs;
      let req: ProceedPaymentModel = {

        caseID: this.reservationSaveAndConfirmModel.CaseID,
        depositeTypeEnum: this.depositeType,
        paymentMethod: paymentMethod,
        paymentMode: PaymentMode.New,
        rentalServiceDeliveryChannelID: RentalServiceDeliveryChannel.Online,
        payTabsToken: response.token,
        payTabsCustomerDetails: this.customerDetails
      }
      this.callProceedPayment(paymentMethod, req);


    }
    if (response.error) {
      paylib.handleError(document.getElementById('paymentErrors'), response);
    }

  }


  updatePayTabsCardType(ct, accepted) {

    switch (ct) {
      case "visa":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.Visa;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-visa-brand"></i>';

        if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.Visa)[0] != null) {
          this.payTabsFormIsDisable = false;
          document.getElementById('paymentErrors').innerHTML = '';
        } else {
          this.payTabsFormIsDisable = true;
          this.translate.get('CardNotSupported').subscribe(res => {
            document.getElementById('paymentErrors').innerHTML = res;
          })
        }


        break;
      case "electron":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-electron-brand"></i>';
        this.payTabsFormIsDisable = true;
        this.translate.get('SomethingWentWrong').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        })

        break;
      case "mastercard":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.MasterCard;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-mastercard-brand"></i>';

          if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.MasterCard)[0] != null) {
            this.payTabsFormIsDisable = false;
            document.getElementById('paymentErrors').innerHTML = '';
          } else {
            this.payTabsFormIsDisable = true;
            this.translate.get('CardNotSupported').subscribe(res => {
              document.getElementById('paymentErrors').innerHTML = res;
            })
          }

        break;
      case "maestro":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-maestro-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });

        break;
      case "amex":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.AmericanExpress;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-amex-brand"></i>';

          if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.AmericanExpress)[0] != null) {
            this.payTabsFormIsDisable = false;
            document.getElementById('paymentErrors').innerHTML = '';
          } else {
            this.payTabsFormIsDisable = true;
            this.translate.get('CardNotSupported').subscribe(res => {
              document.getElementById('paymentErrors').innerHTML = res;
            })
          }
        break;
      case "discover":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-discover-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });
        break;
      case "jcb":
        //this.paymentGatewayMethod=PaymentGatewayMethodEnum.Visa;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-jcb-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });
        break;
      case "diners":
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-diners-brand"></i>';
        break;
      case "mada":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.Mada;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-mada-brand"></i>';

          if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.Mada)[0] != null) {
            this.payTabsFormIsDisable = false;
            document.getElementById('paymentErrors').innerHTML = '';
          } else {
            this.payTabsFormIsDisable = true;
            this.translate.get('CardNotSupported').subscribe(res => {
              document.getElementById('paymentErrors').innerHTML = res;
            })
          }
        break;
      case "omannet":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-omannet-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });

        break;
      case "cup":
        this.paymentGatewayMethod = PaymentGatewayMethodEnum.UnionPay;
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-cup-brand"></i>';



          if (this.payTabsPaymentMethods.filter(a => a.paymentMethodLookupID == PaymentGatewayMethodEnum.UnionPay)[0] != null) {
            this.payTabsFormIsDisable = false;
            document.getElementById('paymentErrors').innerHTML = '';
          } else {
            this.payTabsFormIsDisable = true;
            this.translate.get('CardNotSupported').subscribe(res => {
              document.getElementById('paymentErrors').innerHTML = res;
            })
          }
        break;
      case "meeza":

        document.querySelector(".card-type").innerHTML =
          '<i class="pt-meeza-brand"></i>';

        this.payTabsFormIsDisable = true;
        this.translate.get('CardNotSupported').subscribe(res => {
          document.getElementById('paymentErrors').innerHTML = res;
        });

        break;
      default:
        document.querySelector(".card-type").innerHTML =
          '<i class="pt-credit-card-brand"></i>';
    }
  };






}
